import { Controller } from "@hotwired/stimulus"
import { createTimeline } from "animejs"

// Connects to data-controller="components--flash-messages"
export default class extends Controller {
  static targets = [
    "timer",
    "message"
  ]

  static values = {
    delay: Number
  }

  connect() {
  }

  messageTargetConnected() {
    this.timeline = createTimeline({
      defaults: {
        duration: 800,
      },
      loop: false,
      onBegin: () => {
        this.messageTarget.classList.remove("hidden")
      }
    })

    this.timeline
      .add(this.messageTarget, {
        translateY: ["100%", "0%"],
        opacity: [0, 1],
        easing: "easeOutQuad"
      }, 0)
      .add(this.timerTarget, {
        duration: this.messageTarget.dataset.duration,
        easing: "linear",
        onUpdate: (anim) => {
          let progress = Math.floor(anim.progress * 100)

          if (progress < 100) {
            this.timerTarget.style.width = `${progress}%`
          }
        }
      }, 0)

    this.timeline.play()

    this.timeout = setTimeout(() => {
      this.timeline
        .add(this.messageTarget, {
          translateY: ["0%", "100%"],
          opacity: [1, 0],
          duration: 500,
          easing: "easeOutQuad"
        }, 0)
    }, this.messageTarget.dataset.duration)
  }

  messageTargetDisconnected() {
    clearTimeout(this.timeout)
  }
}
